import * as AppConst from '@/store/modules/Constants';
import { DefaultPlatform } from '@/modules/library/constants';
import { HTTPAction } from '../../store/modules/app/types';
import { apiRequest } from '../../store/modules/ApiRequestHelper';
import { AppDownloadUrlsUpdateRequest } from '@/modules/version/types';

export const actions = {
  // Submit new version entry
  async submitNewVersionEntry(context, payload) {
    if (!payload || Object.keys(payload).length === 0) {
      return Promise.reject('invalid payload passed to submitNewVersionEntry, payload should be a Version item');
    } else {
      const mutationName = payload.Platform === DefaultPlatform ? 'updateDesktopVersion' : 'updateIOSVersion';

      return apiRequest(
        {
          action: HTTPAction.POST,
          url: AppConst.createNewVersionUrl,
          body: payload,
        },
        context,
        mutationName,
        `submit new version entry: ${payload}`
      );
    }
  },
  async getLatestVersionUrl(context, payload) {
    const mutationName = payload.indexOf(DefaultPlatform) >= 0 ? 'updateDesktopVersion' : 'updateIOSVersion';

    return apiRequest(
      {
        action: HTTPAction.GET,
        url: `${AppConst.versionUrl}/${payload}`,
        params: {},
      },
      context,
      mutationName,
      AppConst.versionErrorName
    );
  },
  createVersionPrompt(context, payload) {
    context.commit(AppConst.SetApiErrorMutationName,
      `There is no ${payload.platform} app version available, please create a minimum 3.11.0.0 ${payload.platform} version first.`, { root: true });
    context.commit(AppConst.loadingMutationName, false, { root: true });
    context.commit(AppConst.loadingModalMutationName, false, { root: true });
  },
  async updateBranchIODeeplinkDownloadUrl(context, payload /* : AppDownloadUrlsUpdateRequest */) {
    if (!payload || Object.keys(payload).length === 0) {
      return Promise.reject('invalid payload passed to updateBranchIODeeplinkDownloadUrl, payload should be conforming to type AppDownloadUrlsUpdateRequest');
    } else {
      return apiRequest(
        {
          action: HTTPAction.PUT,
          url: AppConst.branchIODownloadUrlsV1,
          body: payload,
        },
        context,
        '',
        `update BranchIO deeplink download URL with payload: ${payload}`
      );
    }
  },
};
